import { Download } from "lucide-react";
import PropTypes from "prop-types";
import LoadingButton from "@components/ui-components/loading-button";
import Modal from "@components/ui-components/modal";
import DocumentPreview from "./document-preview";
import { pdfFileName } from "../misc/helpers";

// A contract document on screen and nothing else: no acknowledgement, just the
// reader and a download. Driven by use-document-viewer.
const ContractPreviewModal = ({ open, contract, subtitle = "", viewer, onClose }) => {
    if (!open || !contract) return null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            width="xl"
            title={contract.name}
            subtitle={subtitle}
            footer={(
                <>
                    <LoadingButton
                        color="neutral"
                        size="sm"
                        icon={Download}
                        text="Download"
                        href={contract.url}
                        download={pdfFileName(contract.name)}
                        disabled={!contract.url}
                        testId="download-contract-preview" />
                    <LoadingButton
                        color="dark"
                        size="sm"
                        text="Close"
                        onClick={onClose}
                        testId="close-contract-preview" />
                </>
            )}>
            {/* Nothing is gated on having opened it, so there is nothing to record. */}
            <DocumentPreview contract={contract} viewer={viewer} onOpenExternally={() => {}} />
        </Modal>
    );
};

ContractPreviewModal.propTypes = {
    open    : PropTypes.bool.isRequired,
    contract: PropTypes.shape({
        name       : PropTypes.string,
        url        : PropTypes.string,
        previewKind: PropTypes.string
    }),
    subtitle: PropTypes.string,
    viewer  : PropTypes.object.isRequired,
    onClose : PropTypes.func.isRequired
};

export default ContractPreviewModal;
